export default "__VITE_ASSET__zNrT0UFe__"